export default __webpack_public_path__ + "static/media/lightning-icon.4964f997.png";